(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["lmn"] = factory();
	else
		root["lmn"] = root["lmn"] || {}, root["lmn"]["ui"] = root["lmn"]["ui"] || {}, root["lmn"]["ui"]["obe"] = root["lmn"]["ui"]["obe"] || {}, root["lmn"]["ui"]["obe"]["loader"] = factory();
})(self, () => {
return 